// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/scss/animations.scss
// module id = 245
// module chunks = 6